import { ManufacturerMapping } from '../custom-manufacturer-campaign/custom-manufacturer-campaign.models';

export interface VendorReportTransferData {
  vendorReportMerchantDataPk?: string;
  manufacturer?: string;
  reportTransferType?: string;
  reportTransferPeriod?: string;
  transferDate?: Date;
  fileName?: string;
  timeStamp?: Date;
  reportTransferStatus?: string;
  dataCount?: number;
  reportCountry?: string;
  reportChannel?: string;
  b2bUnit?: string;
  reportCategory?: String;
  inventoryReportDate?:string;
}

export enum ReportCountry {
  DE,
  AT,
  NL,
}

export enum ReportTransferType {
  Sales,
  Inventory,
}

export enum ReportTransferStatus {
  Open,
  Success,
  NoData,
  DataModified,
  Error,
}
export enum ReportCategory{
  Daily,
  Weekly,
  Monthly
}
export enum SalesTransactionType {
  S,
  R,
}

export enum ReportChannel {
  Online,
  General,
  Store,
}

export enum YESNO {
  YES,
  NO,
}

export enum ReportProductSupplier {
  Vendor,
  Other,
}

export enum CustomVendorReportingSortOptions {
  reportTransferPeriod,
  transferDate,
  timeStamp,
}

export enum ProductCodeType {
  H,
  R,
  E,
}

export class CustomVendorReportingSearchFilters {
  productCode?: string;
  supplierProductCode?: string;
  ean?: string;
  manufacturer?: string;
  reportTransferType?: string;
  reportTransferStatus?: string;
  reportTransferPeriod?: string;
  transferDateFrom?: string;
  transferDateTo?: string;
  b2bUnit?: string;
  reportCategory?: string;
  reportTransferPeriodFrom?: string;
  reportTransferPeriodTo?: string;
  reportChannel?: string;
}

export interface CustomVendorReportingOverviewList {
  responses?: VendorReportTransferData[];
}

export interface ManufacturerMappingList {
  responses?: ManufacturerMapping[];
}

export interface VendorReportingDetailResponse {
  responses?: VendorReportingDetailData[];
}

export interface VendorReportingDetailData {
  pk?: string;
  updated?: boolean;
}

export interface CanonDetailsData extends VendorReportingDetailData {
  productCode?: string;
  manufacturerPartNumber?: string;
  gtin?: number;
  productName?: string;
  quantity?: number;
  bundle?: string;
  transactionType?: string;
  productSupplier?: string;
  onlineSale?: string;
  marketplaceSale?: string;
  inventoryDate?: string;
  invoiceDate?: string;
  branchId?: string;
  productCodeType?: string;
  storeId?: string;
}

export interface VendorReportingDetailResultsData {
  messageKey?: string;
  productCode?: string;
  inventoryDate?: string;
}

export enum VendorReportingManufacturers {
  CANON = 'Canon',
}

export enum RioDataEvaluationSortOptions {
  b2bUnit,
  productCode,
  manufacturerPartNumber,
  gtin,
  date,
}

export interface RioDataEvaluationData{
  manufacturer?: string;
  reportTransferType?: string;
  productCode?: string;
  manufacturerPartNumber?: string;
  gtin?: number;
  quantity?: number;
  b2bUnit?: string;
  transactionType?: string;
  onlineSale?: string;
  date?: string;
  storeId?: string;
}


export interface RioStatisticsData {
  searchResultB2BUnitCount?:number,
  searchResultProductCount?:number,
  searchResultRecordCount?:number,
  searchResultReturnQuantityCount?:number,
  searchResultSalesQuantityCount?:number,
}
export interface CustomRioDataEvaluationOverviewList {
  responses?: RioDataEvaluationData[];
  statistics?:RioStatisticsData;
}
